import { render, staticRenderFns } from "./SummaryManagementRecommendations.vue?vue&type=template&id=dde93184&scoped=true"
import script from "./SummaryManagementRecommendations.vue?vue&type=script&lang=js"
export * from "./SummaryManagementRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde93184",
  null
  
)

export default component.exports